import { useParams } from 'react-router-dom';
import { getPublicShareBundle } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { ClientDashboard } from './ClientDashboard';
import { T, sharedStyles } from '../components/Shared';
import { useIsMobile } from '../lib/useIsMobile';

export function PublicShareView() {
  const { token } = useParams<{ token: string }>();
  const isMobile = useIsMobile();
  const state = useAsync(
    () => {
      if (!token || token.length < 16) {
        return Promise.reject(new Error('invalid token'));
      }
      return getPublicShareBundle(token);
    },
    [token],
  );

  if (state.status === 'loading') {
    return <CenteredMessage title="Loading…" />;
  }

  if (state.status === 'error') {
    return (
      <CenteredMessage
        title="Link expired or invalid"
        detail="The share link you used is no longer valid. Please contact YEA Business for a new link."
      />
    );
  }

  return (
    <div style={isMobile
      ? { minHeight: '100vh' }
      : { height: '100vh', overflow: 'hidden' }}>
      <ClientDashboard bundle={state.data} readOnly />
    </div>
  );
}

function CenteredMessage({ title, detail }: { title: string; detail?: string }) {
  return (
    <div style={{
      minHeight: '100vh', background: '#f8f9fa',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{
          fontFamily: sharedStyles.fontDisplay, fontSize: 22, fontWeight: 700,
          color: T.fgPrimary, marginBottom: 8,
        }}>
          {title}
        </div>
        {detail && (
          <div style={{ fontSize: 14, color: T.fgSecondary, lineHeight: 1.5 }}>{detail}</div>
        )}
      </div>
    </div>
  );
}
